import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Wine, DoorClosed, Ticket, UserCheck, ArrowRight, Sparkles } from 'lucide-react';
const bookingOptions = [{
  id: 'bottle-service',
  title: 'Bottle Service',
  description: 'Reserve a VIP table with premium bottle service for your group.',
  icon: Wine,
  image: 'https://images.unsplash.com/photo-1574643156929-51fa098b0394?w=800&h=600&fit=crop',
  link: '/bottle-service',
  cta: 'Reserve Table'
}, {
  id: 'private-rooms',
  title: 'Private Rooms',
  description: 'Exclusive suites and lounges for intimate gatherings and parties.',
  icon: DoorClosed,
  image: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&h=600&fit=crop',
  link: '/book-room',
  cta: 'View Rooms'
}, {
  id: 'tickets',
  title: 'Tickets & Events',
  description: 'Purchase tickets for upcoming shows, DJ sets, and special events.',
  icon: Ticket,
  image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&h=600&fit=crop',
  link: '/events',
  cta: 'Browse Events'
}, {
  id: 'vip-hosts',
  title: 'Connect with a Host',
  description: 'Personalized service from our dedicated VIP host team.',
  icon: UserCheck,
  image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop',
  link: '/vip-hosts',
  cta: 'Find a Host'
}];
export function BookNow() {
  return <div className="min-h-screen bg-[#0B1014] text-white selection:bg-[#DDA247] selection:text-[#0B1014]" data-id="element-685">
      <Header data-id="element-686" />

      <main className="pt-32 pb-20 px-4 md:px-6" data-id="element-687">
        {/* Hero Section */}
        <div className="container mx-auto max-w-7xl mb-16 text-center relative" data-id="element-688">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#DDA247]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-689" />

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="relative z-10" data-id="element-690">
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-691">
              <Sparkles className="w-5 h-5 text-[#DDA247]" data-id="element-692" />
              <span className="text-sm text-[#DDA247] uppercase tracking-[0.2em] font-medium" data-id="element-693">
                Reservations
              </span>
              <Sparkles className="w-5 h-5 text-[#DDA247]" data-id="element-694" />
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white uppercase tracking-tight mb-6 leading-tight" data-id="element-695">
              Choose Your
              <br data-id="element-696" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-[#DDA247] to-[#DDA247]" data-id="element-697">
                Experience
              </span>
            </h1>

            <p className="text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-698">
              Secure your spot at the city's premier nightlife destination.
              Select from our range of premium booking options below.
            </p>
          </motion.div>
        </div>

        {/* Options Grid */}
        <div className="container mx-auto max-w-7xl" data-id="element-699">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-700">
            {bookingOptions.map((option, index) => <motion.div key={option.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1 + 0.3
          }} data-id="element-701">
                <Link to={option.link} className="group relative block h-[400px] overflow-hidden rounded-3xl border border-white/10" data-id="element-702">
                  {/* Background Image */}
                  <div className="absolute inset-0" data-id="element-703">
                    <img src={option.image} alt={option.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-704" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0B1014] via-[#0B1014]/60 to-transparent opacity-90 transition-opacity duration-500 group-hover:opacity-80" data-id="element-705" />
                  </div>

                  {/* Content */}
                  <div className="absolute inset-0 p-8 flex flex-col justify-end items-start" data-id="element-706">
                    <div className="mb-auto bg-white/10 backdrop-blur-md p-3 rounded-xl border border-white/10 group-hover:bg-[#DDA247] group-hover:border-[#DDA247] transition-colors duration-300" data-id="element-707">
                      <option.icon className="w-6 h-6 text-white group-hover:text-[#0B1014] transition-colors duration-300" data-id="element-708" />
                    </div>

                    <div className="transform transition-transform duration-500 translate-y-4 group-hover:translate-y-0" data-id="element-709">
                      <h3 className="text-3xl font-bold text-white mb-3 uppercase tracking-wide" data-id="element-710">
                        {option.title}
                      </h3>
                      <p className="text-gray-300 mb-6 max-w-md line-clamp-2 group-hover:text-white transition-colors" data-id="element-711">
                        {option.description}
                      </p>

                      <div className="flex items-center gap-2 text-[#DDA247] font-bold uppercase tracking-wider text-sm group-hover:text-white transition-colors" data-id="element-712">
                        {option.cta}
                        <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-713" />
                      </div>
                    </div>
                  </div>
                </Link>
              </motion.div>)}
          </div>
        </div>

        {/* Contact Strip */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="container mx-auto max-w-7xl mt-20" data-id="element-714">
          <div className="bg-[#1A2228] rounded-2xl p-8 md:p-12 border border-white/5 text-center relative overflow-hidden" data-id="element-715">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#DDA247]/5 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/2" data-id="element-716" />

            <h3 className="text-2xl font-bold text-white mb-4 relative z-10" data-id="element-717">
              Need Custom Arrangements?
            </h3>
            <p className="text-gray-400 mb-8 max-w-2xl mx-auto relative z-10" data-id="element-718">
              For large corporate events, full venue buyouts, or specific
              requirements not listed above, please contact our events team
              directly.
            </p>
            <Link to="/contact" className="inline-flex items-center justify-center px-8 py-3 bg-transparent border border-[#DDA247] text-[#DDA247] hover:bg-[#DDA247] hover:text-[#0B1014] rounded-xl font-bold uppercase tracking-wider transition-all duration-300 relative z-10" data-id="element-719">
              Contact Events Team
            </Link>
          </div>
        </motion.div>
      </main>

      <Footer data-id="element-720" />
    </div>;
}